/* COLOMBY COFFEE — interactions */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isRTL = document.documentElement.dir === 'rtl';

  /* Reveal on scroll */
  var revealObserver = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            revealObserver.unobserve(e.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 })
    : null;

  function initReveal(root) {
    root.querySelectorAll('[data-cb-reveal]:not(.is-in)').forEach(function (el) {
      if (revealObserver && !reduce) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* Toast */
  var toastEl;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'cb-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2200);
  }

  /* Copy discount code */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cb-copy]');
    if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-cb-copy');
    var done = function () { toast('تم نسخ الكود ' + code); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, done);
    } else {
      var t = document.createElement('textarea');
      t.value = code; document.body.appendChild(t); t.select();
      try { document.execCommand('copy'); } catch (err) {}
      t.remove(); done();
    }
  });

  /* Hero slider */
  function initHero(root) {
    root.querySelectorAll('[data-cb-hero]').forEach(function (hero) {
      if (hero._cbInit) return;
      hero._cbInit = true;
      var slides = Array.prototype.slice.call(hero.querySelectorAll('.cb-slide'));
      var dots = Array.prototype.slice.call(hero.querySelectorAll('.cb-hero__dot'));
      var speed = parseInt(hero.getAttribute('data-speed'), 10) || 6000;
      var idx = 0, timer = null;

      function go(i) {
        if (!slides.length) return;
        idx = (i + slides.length) % slides.length;
        slides.forEach(function (s, n) {
          s.classList.toggle('is-active', n === idx);
          s.setAttribute('aria-hidden', n === idx ? 'false' : 'true');
        });
        dots.forEach(function (d, n) {
          d.classList.remove('is-active');
          void d.offsetWidth;
          if (n === idx) d.classList.add('is-active');
          d.setAttribute('aria-current', n === idx ? 'true' : 'false');
        });
        schedule();
      }
      function schedule() {
        clearTimeout(timer);
        if (slides.length > 1 && !reduce && !hero.classList.contains('is-paused') && !hero.classList.contains('is-offscreen')) {
          timer = setTimeout(function () { go(idx + 1); }, speed);
        }
      }
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
      hero.addEventListener('mouseenter', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
      hero.addEventListener('mouseleave', function () { hero.classList.remove('is-paused'); schedule(); });

      var sx = null;
      hero.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) go(idx + ((dx < 0) !== isRTL ? 1 : -1));
        sx = null;
      });

      if (!reduce && window.matchMedia('(pointer: fine)').matches) {
        var beans = hero.querySelectorAll('.cb-hero__bean');
        var media = hero.querySelectorAll('.cb-slide__media');
        hero.addEventListener('mousemove', function (e) {
          var r = hero.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          beans.forEach(function (b) {
            var depth = parseFloat(b.getAttribute('data-depth')) || 20;
            b.style.setProperty('--px', (x * depth).toFixed(1) + 'px');
            b.style.setProperty('--py', (y * depth).toFixed(1) + 'px');
          });
          media.forEach(function (m) {
            m.style.transform = 'translate3d(' + (x * -14).toFixed(1) + 'px,' + (y * -10).toFixed(1) + 'px,0)';
          });
        });
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          en.forEach(function (x) {
            if (x.isIntersecting) { hero.classList.remove('is-offscreen'); schedule(); }
            else { hero.classList.add('is-offscreen'); clearTimeout(timer); }
          });
        }).observe(hero);
      }
      go(0);
    });
  }

  /* Carousels */
  function initCarousels(root) {
    root.querySelectorAll('[data-cb-carousel]').forEach(function (wrap) {
      if (wrap._cbInit) return;
      wrap._cbInit = true;
      var track = wrap.querySelector('.cb-carousel__track');
      var section = wrap.closest('.cb-section') || wrap;
      section.querySelectorAll('[data-cb-dir]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-cb-dir') === 'next' ? 1 : -1;
          var card = track.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 20 : 300;
          track.scrollBy({ left: dir * step * (isRTL ? -1 : 1), behavior: reduce ? 'auto' : 'smooth' });
        });
      });
    });
  }

  /* Roast finder tabs */
  function initTabs(root) {
    root.querySelectorAll('[data-cb-roast]').forEach(function (wrap) {
      if (wrap._cbInit) return;
      wrap._cbInit = true;
      var tabs = wrap.querySelectorAll('[role="tab"]');
      var panels = wrap.querySelectorAll('.cb-roast__panel');
      var visuals = wrap.querySelectorAll('[data-roast-visual]');
      function select(i) {
        tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
        panels.forEach(function (p, n) {
          p.classList.toggle('is-active', n === i);
          if (n === i) {
            p.querySelectorAll('.cb-meter__bar span.on').forEach(function (s) { s.classList.remove('on'); void s.offsetWidth; s.classList.add('on'); });
          }
        });
        visuals.forEach(function (v, n) { v.hidden = n !== i; });
        var color = tabs[i] && tabs[i].getAttribute('data-roast-color');
        if (color) wrap.style.setProperty('--roast', color);
      }
      tabs.forEach(function (t, n) {
        t.addEventListener('click', function () { select(n); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, next = null;
          if (k === 'ArrowLeft') next = isRTL ? n + 1 : n - 1;
          if (k === 'ArrowRight') next = isRTL ? n - 1 : n + 1;
          if (next !== null) { e.preventDefault(); next = (next + tabs.length) % tabs.length; select(next); tabs[next].focus(); }
        });
      });
      select(0);
    });
  }

  /* Reels: play videos in view */
  function initReels(root) {
    var vids = root.querySelectorAll('.cb-reel video');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        var v = x.target;
        v.muted = true;
        if (x.isIntersecting && !reduce) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        else v.pause();
      });
    }, { threshold: 0.4 });
    vids.forEach(function (v) { io.observe(v); });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    initHero(root);
    initCarousels(root);
    initTabs(root);
    initReels(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.cb-slide');
    var hero = e.target.closest('[data-cb-hero]');
    if (slide && hero) {
      var i = Array.prototype.indexOf.call(hero.querySelectorAll('.cb-slide'), slide);
      var dot = hero.querySelectorAll('.cb-hero__dot')[i];
      if (dot) dot.click();
    }
  });
})();
